export const LAYOUT_WIDTH_CLASS_NAMES = 'max-w-screen-2xl mx-auto px-4 xl:px-8 w-full';
